<template>
  <user-profile-picture :userEmail="reply.userid" cssClass="user-icon" />
  <div class="comment-form d-flex flex-column" :id="reply.id">
    <comment-card :comment="reply" :forceShowDeleteCommentButtons="forceShowDeleteCommentButtons" @commentDeleted="emitCommentDeleted" />
  </div> <!-- /comment-form -->
</template>
<script lang="ts">


import { defineComponent } from 'vue'
import UserProfilePicture from './UserProfilePicture.vue'
import moment from 'moment';
import CommentCard from './CommentCard.vue';


export default defineComponent({
  components: { UserProfilePicture, CommentCard },
  name: 'SingleCommentRreply',
  props: {
    reply: Object(),
    forceShowDeleteCommentButtons: Boolean,
  },
  emits: ['commentDeleted'],
  mounted() {
    moment.locale('de')
  },
  computed: {
    commentMarkedAsDeleted():boolean {
      if(this.reply?.title !== undefined && this.reply?.title === '[DELETED]') {
        return true
      }
      return false
    }
  },
  methods: {
    getFromNowString(timestamp:string): string {
      return moment(timestamp, 'X').fromNow();
    },

    getTimeString(timestamp:string): string {
      return moment(timestamp, 'X').format('DD.MM.YYYY, HH:mm:ss');
    },

    emitCommentDeleted(): void {
      this.$emit('commentDeleted')
    }
  }



});

</script>
